import React from "react";

/**
 * Firma > Cihazlar tablosunun yükleme iskeleti — DevicesTable ile aynı
 * sütun düzeni (Cihaz, Kota, Durum, Son Bağlantı, Parçalar, Versiyon,
 * İşlem). MascotLoadingOverlay üstte, iskelet altta kullanılır.
 */
const HEADERS = ["CİHAZ", "KOTA", "DURUM", "SON BAĞLANTI", "PARÇALAR", "VERSİYON", "İŞLEM"];

const Cell = ({ children, right = false }) => (
  <td className={`px-4 py-3 ${right ? "text-right" : ""}`}>{children}</td>
);

const Bar = ({ w = "w-24", h = "h-3.5" }) => (
  <div className={`${h} ${w} bg-gray-200 rounded-md animate-pulse`} />
);

const DevicesTableSkeleton = ({ rows = 6 }) => (
  <div className="h-full overflow-auto bg-white border-t border-gray-200">
    <table className="w-full min-w-[1024px] text-sm">
      <thead>
        <tr>
          {HEADERS.map((h, i) => (
            <th
              key={h}
              className={`sticky top-0 z-10 bg-gray-100 border-b border-gray-200 px-4 py-3 text-xs font-bold text-gray-400 tracking-wide whitespace-nowrap ${
                i === HEADERS.length - 1 ? "text-right" : "text-left"
              }`}
            >
              {h}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: rows }).map((_, i) => (
          <tr key={i} className="border-b border-gray-100">
            {/* Cihaz */}
            <Cell>
              <div className="flex items-center gap-3">
                <div className="w-11 h-11 shrink-0 bg-gray-200 rounded-lg animate-pulse" />
                <div className="space-y-1.5">
                  <Bar w="w-32" />
                  <Bar w="w-24" h="h-3" />
                </div>
              </div>
            </Cell>
            {/* Kota */}
            <Cell>
              <div className="space-y-1.5">
                <Bar w="w-28" />
                <Bar w="w-24" />
              </div>
            </Cell>
            {/* Durum */}
            <Cell>
              <div className="space-y-1.5">
                <Bar w="w-16" h="h-5" />
                <Bar w="w-20" h="h-5" />
              </div>
            </Cell>
            {/* Son Bağlantı */}
            <Cell>
              <Bar w="w-28" />
            </Cell>
            {/* Parçalar */}
            <Cell>
              <div className="flex gap-1.5">
                <Bar w="w-14" h="h-6" />
                <Bar w="w-16" h="h-6" />
              </div>
            </Cell>
            {/* Versiyon */}
            <Cell>
              <div className="space-y-1.5">
                <Bar w="w-24" h="h-5" />
                <Bar w="w-24" h="h-5" />
              </div>
            </Cell>
            {/* İşlem */}
            <Cell right>
              <div className="flex flex-col items-end gap-1.5">
                <Bar w="w-28" h="h-8" />
                <Bar w="w-28" h="h-8" />
              </div>
            </Cell>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default DevicesTableSkeleton;
